import { connect } from 'react-redux'
import Interactions from './Interactions.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsInteractions.chartType,
    granularity: state.analyticsInteractions.granularity,
    dateRange: state.analyticsInteractions.dateRange,
    customDateRange: state.analyticsInteractions.customDateRange,
    channelNameToFilter: state.analyticsInteractions.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.interactionsChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.interactionsChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.interactionsMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.interactionsChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.interactionsChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Interactions)
